import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { loginSucess } from './redux/user/actions';
import axios from './api/axios';

const AuthLoader = ({ children }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const token = localStorage.getItem("authToken");
    const email = localStorage.getItem("email");

    // Quick client-side token validation
    const validateToken = () => {
        if (!token || !email) {
            return false;
        }

        try {
            const decoded = jwtDecode(token);
            const now = Date.now() / 1000;

            // Check if token is expired
            if (decoded.exp < now) {
                console.log("Token expired on client-side");
                return false;
            }
            return true;
        } catch (err) {
            console.log("Invalid token format:", err);
            return false;
        }
    };

    const loadUserData = async () => {
        // If no token or email, skip API call
        if (!token || !email) {
            setLoading(false);
            return;
        }

        // Quick client-side validation first
        if (!validateToken()) {
            setLoading(false);
            return;
        }

        try {
            // ✅ No need for manual headers - interceptor adds them
            const response = await axios.get(`admin-user-management?email=${email}`);

            const userData = response.data.data.dbResponse;

            dispatch(
                loginSucess({
                    token,
                    userId: userData?._id,
                    userRole: response?.data?.data?.user?.role,
                    user: userData,
                    email: userData?.email || email,
                    access: userData?.access,
                })
            );
        } catch (error) {
            // Error is already handled by interceptor (shows toast and redirects)
            console.log("AuthLoader: Failed to load user data", error);
            // Interceptor will handle the redirect, so we just set loading to false
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadUserData();
    }, []);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f5f5f5'
            }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading your session...</p>
                </div>
            </div>
        );
    }

    return children;
};

export default AuthLoader;

// -------- Previous Code --------
// import React, { useEffect, useState } from 'react'
// import { useDispatch } from 'react-redux'
// import { toast } from 'react-toastify';
// import axios from './api/axios';
// import { loginSucess } from './redux/user/actions';
// import jwtDecode from 'jwt-decode';

// // const AuthLoader = ({ children }) => {
// //     const dispatch = useDispatch();
// //     const token = localStorage.getItem("authToken")
// //     const email = localStorage.getItem("email")

// //     const getSingleUser = async (email) => {
// //         try {
// //             const headers = {
// //                 Authorization: `Bearer ${token}`,
// //             };
// //             const response = await axios.get(`admin-user-management?email=${email}`, { headers });

// //             if (response.status === 200) {
// //                 const userData = response.data.data.dbResponse;
// //                 dispatch(
// //                     loginSucess({
// //                         token: token,
// //                         userId: userData?._id,
// //                         userRole: response?.data?.data?.user?.role,
// //                         user: userData,
// //                         email: userData.email,
// //                         access: userData.access
// //                     })
// //                 )
// //             }
// //         } catch (error) {
// //             if (error.response && error.response?.data?.status === false) {
// //                 let errorMessage = error.response.data.error;
// //                 toast.error(errorMessage, {
// //                     position: "top-right",
// //                     autoClose: 3000,
// //                     theme: "colored",
// //                 });
// //             }
// //         }
// //     };

// //     useEffect(() => {
// //         getSingleUser(email)
// //     }, [dispatch, token])

// //     return children;
// // }

// const AuthLoader = ({ children }) => {
//     const dispatch = useDispatch();
//     const [loading, setLoading] = useState(true);
//     const token = localStorage.getItem("authToken");
//     const email = localStorage.getItem("email");

//     const getSingleUser = async (email) => {
//         try {
//         const headers = { Authorization: `Bearer ${token}` };
//         const response = await axios.get(`admin-user-management?email=${email}`, { headers });
//             console.log("Response of Auth Loader :", response);
            
//         if (response.status === 200) {
//             console.log("Response of Auth Loader In If Condition");
            
//             const userData = response.data.data.dbResponse;
//             dispatch(loginSucess({
//                 token,
//                 userId: userData?._id,
//                 userRole: response?.data?.data?.user?.role,
//                 user: userData,
//                 email: userData?.email ? userData?.email : email,
//                 access: userData?.access
//             }));
//         }
//         } catch (error) {
//             console.error(error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (email && token) {
//             getSingleUser(email);
//         } else {
//             setLoading(false);
//         }
//     }, [dispatch, token]);

//     if (loading) {
//         return <div>Loading...</div>; // Or a spinner
//     }

//   return children;
// };


// export default AuthLoader
